var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { selectInsuranceProduct, } from "../../features/applicant/applicantSlice";
import AppBody from "../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../components/Header";
import Image from "../../components/Image";
import { InsuranceProducts } from "../../constants";
import { PHASE } from "../../routeConfig";
import RouteTitle from "../../components/RouteTitle";
import { completedPage } from "../../lib/Avo";
import getShoppingIntentConfig from "../../utils/getShoppingIntentConfig";
import handleResultClick from "../../utils/handleResultClick";
import { shouldOpenInSameWindow } from "../../lib/util";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useMemoryHistory from "../../hooks/useMemoryHistory";
export default function ShoppingExperienceIntroPage() {
    var _a, _b;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _c = useAppSelector(function (state) {
        var shoppingIntent = state.applicant.shoppingIntent.primary;
        var selectedAuto = shoppingIntent.includes(InsuranceProducts.Auto);
        var selectedHome = shoppingIntent.includes(InsuranceProducts.Home);
        var selectedInsuranceProduct = selectedAuto && selectedHome
            ? InsuranceProducts.AutoHome
            : selectedAuto
                ? InsuranceProducts.Auto
                : selectedHome
                    ? InsuranceProducts.Home
                    : undefined;
        return { shoppingIntent: shoppingIntent, selectedInsuranceProduct: selectedInsuranceProduct };
    }), shoppingIntent = _c.shoppingIntent, selectedInsuranceProduct = _c.selectedInsuranceProduct;
    var push = useMemoryHistory().push;
    var dispatch = useAppDispatch();
    var shoppingIntentConfig = getShoppingIntentConfig(shoppingIntent);
    var linkOut = shoppingIntentConfig === null || shoppingIntentConfig === void 0 ? void 0 : shoppingIntentConfig.linkOut;
    var nextRoute = (_b = (_a = shoppingIntentConfig === null || shoppingIntentConfig === void 0 ? void 0 : shoppingIntentConfig.nextRoute) === null || _a === void 0 ? void 0 : _a.call(shoppingIntentConfig)) !== null && _b !== void 0 ? _b : PHASE.SHOPPING_EXPERIENCE_UNSUPPORTED;
    function handleClick(ev) {
        var selectedOption = ev.currentTarget.textContent;
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        if (linkOut) {
            var openInSameWindow = shouldOpenInSameWindow();
            return handleResultClick(linkOut, openInSameWindow);
        }
        if (selectedInsuranceProduct) {
            return dispatch(selectInsuranceProduct({
                product: selectedInsuranceProduct,
                changeRoute: true,
            }));
        }
        push(nextRoute);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, { className: "px-6" },
            React.createElement("div", { className: "mx-auto mb-6 mt-20 flex items-center justify-center" },
                React.createElement(Image, { src: "/assets/icons/green-checkmark.svg", width: 48, height: 48, alt: "" })),
            React.createElement(RouteTitle, { className: "mb-2 text-center font-bold" }, "You're in the right place!"),
            React.createElement("p", { className: "mb-6 text-center text-black-300" },
                "Let's start with finding you",
                " ",
                React.createElement("strong", null, shoppingIntentConfig === null || shoppingIntentConfig === void 0 ? void 0 : shoppingIntentConfig.text),
                " insurance"),
            React.createElement(Button, { onClick: handleClick }, "Continue"))));
}
